import React from "react";
import "../styles/WhyChooseUs.css";
import {
  FaShieldAlt,
  FaBolt,
  FaClock,
  FaChartLine,
  FaHeadset,
  FaTools,
} from "react-icons/fa";

const features = [
  {
    icon: <FaChartLine />,
    title: "Complete ERP",
    text: "Accounts, Inventory, Financial Reports and Fuel Management in one platform.",
  },
  {
    icon: <FaBolt />,
    title: "Real-Time Automation",
    text: "Monitor live nozzle sales, operators and tank stock instantly.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Secure System",
    text: "Reliable database with role based access and secure transactions.",
  },
  {
    icon: <FaClock />,
    title: "Fast Installation",
    text: "Professional installation with minimum downtime.",
  },
  {
    icon: <FaTools />,
    title: "Hardware Integration",
    text: "Printers, Dispensers, LED Displays and Controllers.",
  },
  {
    icon: <FaHeadset />,
    title: "24/7 Support",
    text: "Dedicated technical team always available for assistance.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="why" id="why">
      <div className="heading">
        <span>WHY ITWORLD</span>
        <h2>Why Fuel Stations Trust ITWORLD</h2>
        <p>
          We combine enterprise software with industrial hardware to provide
          complete automation solutions for modern petrol pumps.
        </p>
      </div>

      <div className="why-grid">
        {features.map((item, index) => (
          <div className="why-card" key={index}>
            <div className="why-icon">{item.icon}</div>

            <h3>{item.title}</h3>

            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
